import React from "react"

export const SolucionesHeaders = ({ cNameSolucion, titleSolucion }) => {
  return (
    <div
      className={`info-${cNameSolucion}-header-container`}
      data-sal="slide-up"
      data-sal-delay="200"
      data-sal-easing="ease"
    >
      <div className={`info-${cNameSolucion}-logo-container`}>
        <img
          src={`../../soluciones/${cNameSolucion}/${cNameSolucion}.svg`}
          alt={`${cNameSolucion} logo`}
        />
      </div>
      <div className={`info-${cNameSolucion}-title-container`}>
        <h1>{titleSolucion}</h1>
      </div>
    </div>
  )
}
